import { useAuth0 } from "@auth0/auth0-react";
import { getJwtPayload } from "../../utilities/getJwtPayload";
import { Button } from "@mui/material";

export default function GetAccessTokenWithAllScopes({ setSnackbarMessage }) {
    const { getAccessTokenSilently } = useAuth0();

    const getAccessTokenWithAllScopes = async () => {
        const token = await getAccessTokenSilently();
        const payload = getJwtPayload(token);
        const scope = payload.permissions?.join(" ");
        const tokenWithAllScopes = await getAccessTokenSilently({
            authorizationParams: {
                scope,
            },
        });
        await navigator.clipboard.writeText(tokenWithAllScopes);
        setSnackbarMessage("Copied token to clipboard");
    };

    return (
        <Button variant="contained" onClick={getAccessTokenWithAllScopes}>
            Get access token with all scopes
        </Button>
    );
}
